<template>
    <form @submit.prevent="saveData()" class="titan-form" novalidate>
        <div :class="sectionStyleClass" v-for="(form, index) of schemaItems">
            <div :class="sectionHeaderClass"
                 v-if="form.showHeading === undefined ? true : form.showHeading">
                <div class="card-header-buttons" v-if="renderInCard === true && editable === true">
                    <slot :name="getHeaderButtons(form, index)" v-bind:item="form"></slot>
                    <button
                      v-if="showActionButton"
                      type="button"
                      class="btn"
                      @click="saveData()"
                      :class="{'btn-success': newItem, 'btn-primary': !newItem, }"
                    >
                        <font-awesome-icon :icon="newItem === true ? 'plus' : 'check'"/>
                        <span v-if="!newItem">{{t('Save')}}</span>
                        <span v-if="newItem">{{t('Create')}}</span>
                    </button>
                </div>
                {{ (typeof form.name === 'function') ? form.name() : form.name }}
            </div>
            <div :class="sectionBodyClass + ' text-center'" v-if="loading === true">
                <loading class="mb-1" size="xs"/>
                {{t('Loading form')}}
            </div>
            <template v-if="loading === false">
                <div :class="sectionBodyClass" v-if="form.type === 'main'">
                    <vue-form-generator :ref="'form-' + index"
                                        :schema="form"
                                        :model="model"
                                        :options="formOptions"
                                        @model-updated="onFormUpdate"

                    />
                </div>
                <one-to-many :ref="'form-' + index"
                             :model="model"
                             :schema="form"
                             :class="sectionBodyClass"
                             :editable="editable"
                             v-if="form.type === 'oneToMany'"
                >
                    <template :slot="form.model + '-item-header'" slot-scope="slotData">
                        <slot v-bind:item="slotData.item" :name="form.model + '-item-header'"></slot>
                    </template>
                </one-to-many>
            </template>
        </div>
        <input type="submit" class="d-none">
    </form>
</template>
<script>
  import Vue from 'vue'
  import VueFormGenerator from 'vue-form-generator'
  import OneToMany from './OneToMany'
  import Loading from '../Components/loading'
  import FormGenerator from './vfg/formGenerator'

  // Fields
  import TitanAutocomplete from './Fields/Autocomplete'
  import TitanSwitch from './Fields/Switch'
  import TitanLanguage from './Fields/Language'
  import TitanDatePicker from './Fields/Datepicker'
  import TitanSelect from './Fields/Select'
  import Redactor from './Fields/Redactor'
  import Image from './Fields/Image'
  import ConditionalMultiInput from './Fields/ConditionalMultiInput'
  import Password from './Fields/Password'
  import Epicrisis from './Fields/Epicrisis'
  import CardioDrugs from './Fields/CardioDrugs'
  import VszpDrugs from './Fields/VszpDrugs'

  Vue.component("field-titanAutocomplete", TitanAutocomplete);
    Vue.component("field-titanSwitch", TitanSwitch);
    Vue.component("field-titanLanguage", TitanLanguage);
    Vue.component("field-titanDatePicker", TitanDatePicker);
    Vue.component("field-titanSelect", TitanSelect);
    Vue.component("field-titanRedactor", Redactor);
    Vue.component("field-titanImage", Image);
    Vue.component("field-ConditionalMultiInput", ConditionalMultiInput);
    Vue.component("field-password", Password);
    Vue.component("field-titanEpicrisis", Epicrisis);
    Vue.component("field-cardioDrugs", CardioDrugs);
    Vue.component("field-vszpDrugs", VszpDrugs);

    export default {
        components: {
            Loading,
            OneToMany,
            'vue-form-generator': FormGenerator,
        },
        props: {
            model: {
                type: Object,
                required: true,
            },
            schema: {
                type: Array,
                required: true,
            },
            renderInCard: {
                type: Boolean,
                required: false,
                'default': true,
            },
            newItem: {
                type: Boolean,
                required: false,
                'default': false
            },
            showMessage: {
                type: Boolean,
                required: false,
                'default': true
            },
            editable: {
                type: Boolean,
                required: false,
                'default': true
            },
            onFormUpdate: {
                type: Function,
                required: false,
                'default': (newVal,changedModel) => {}
            },
            showActionButton: {
                type: Boolean,
                required: false,
                'default': true
            },
        },
        mounted() {
            // console.log('mounted');
            // this.getFields().forEach(field => {
            //     let model = field.model;
            //     let column = 'n/a';
            //     if(model) {
            //         column = model.replace(/[\w]([A-Z])/g, function(m) {
            //             return m[0] + "_" + m[1];
            //         }).toLowerCase();
            //     }
            //
            //     field.hint = model + ' | ' + column;
            // });
        },
        created() {
            this.loadCodeBooks();
            this.setTranslates();
        },
        computed: {
            schemaItems() {

                return this.schema.filter(res => {
                    const visible = res.visible === undefined ? true : res.visible;
                    return typeof visible === 'function' ? visible() : visible;
                });
            },
            sectionStyleClass() {
                return this.renderInCard === true ? 'card' : 'titan-form-block';
            },
            sectionHeaderClass() {
                return this.renderInCard === true ? 'card-header' : 'titan-form-block-title';
            },
            sectionBodyClass() {
                return this.renderInCard === true ? 'card-body' : 'titan-form-block-body';
            }
        },
        methods: {
            getFields(formIndex = null) {
                let fields = [];
                this.schema.forEach((form,index) => {
                    if(formIndex === null || index === formIndex) {
                        if(form.hasOwnProperty('fields')) {
                            form.fields.forEach(item => {
                                fields.push(item);
                            })
                        }
                        else if(form.hasOwnProperty('groups')) {
                            form.groups.forEach(groupItem => {
                                groupItem.fields.forEach(item => {
                                    fields.push(item);
                                });
                            });
                        }
                    }

                });
                return fields;
            },
            getForms() {
              return this.schema;
            },
            setTranslates() {
                Object.keys(VueFormGenerator.validators.resources).forEach(key => {
                    VueFormGenerator.validators.resources[key] = this.t(key);
                })
            },
            getHeaderButtons(schemaItem, index) {
                return (schemaItem.key === undefined ? index : schemaItem.key) + '-header-buttons';
            },
            loadCodeBooks() {
                let codeBooks = [];
                this.getFields().forEach(item => {
                    if (item.codeBook !== undefined && item.codeBook !== null) {
                        codeBooks.push(item.codeBook);
                    }

                    if (this.model[item.key] === undefined) {
                        this.model[item.key] = item.default !== undefined
                            ? item.default
                            : null;
                    }
                });

                if (codeBooks.length === 0) {
                    this.loading = false
                    this.$emit('loadedCodeBook')
                } else {
                    this.$store.dispatch('codeBook/load', codeBooks.join(',')).then(() => {
                        this.loading = false;
                        this.$emit('loadedCodeBook')
                    }).catch(() => {
                        this.loading = false
                        this.$emit('codeBookLoadFailed')
                    });
                }
            },
            isValid() {
                let valid = true;
                this.getForms().forEach((item, index) => {
                    if (this.$refs['form-' + index] !== undefined) {
                        const formRef = this.$refs['form-' + index][0];
                        let validSubForm = true;

                        if (formRef === undefined) {
                            console.log("Form ref is undefined, why?");
                            return false;
                        } else if (typeof formRef.validate === 'function') {
                            formRef.validate();
                            validSubForm = formRef.errors.length === 0 ? valid : false;
                        } else if (typeof formRef.isValid === 'function') {
                            validSubForm = formRef.isValid() ? valid : false;
                        } else {
                            console.log('Something went wrong in form validation !!!')
                        }
                        if (validSubForm === false) {
                            valid = false;
                        }
                    }
                });
                if (valid === false && this.showMessage === true) {
                    this.$store.dispatch('alert/warning', 'Form has invalid data. Check it and try again.');
                }
                return valid;
            },
            saveData() {
                this.$emit('beforeSave');
                if (this.isValid()) {
                    this.$emit('saveData');
                }


            }
        },
        data() {
            return {
                loading: true,
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: false
                }
            }
        }
    }
</script>
<style lang="scss">
    .titan-form {
      label:hover {
        .tag-helper {
          display:inline !important;
        }
      }
      label {
        .tag-helper {
          padding:5px;
          display:block !important;
          width: 180px;
          position: absolute;
          font-size:12px;
          top: -12px;
          left: 0;
          background-color:white;
          border:2px solid #dadada;
          z-index:100;
        }
      }
        .hint {
            font-size: 13px;
            color: #717171;
        }

        .form-control {
            &:disabled {
                opacity: .6;
            }
        }

        .card {
            .card-header {
                padding-right: 85px;
            }
        }

    }

    .titan-form-block-title {
        font-weight: bold;
        font-size: 18px;
    }

    .titan-form-block {
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/core/Form/Form.vue